window.nextSibling = function (element, selector) {
    // Get the next sibling element
    var sibling = element.nextElementSibling;
    // If there's no selector, return the first sibling
    if (!selector) {
        return sibling;
    }
    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
};
window.previousSibling = function (element, selector) {
    // Get the previous sibling element
    var sibling = element.previousElementSibling;
    // If there's no selector, return the first sibling
    if (!selector) {
        return sibling;
    }
    // If the sibling matches our selector, use it
    // If not, jump to the previous sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.previousElementSibling;
    }
};
